import React, { useEffect } from "react";
import Header from "./header/Header";
import Body from "./body/Body";
import Button from "../../../common/Button";
import Closer from "../container/Closer";
import { useSelector } from "react-redux";
import { TYPE } from "../../../../constant";

const Tutorial = ( props ) => {
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const user = useSelector( state => state.user );

  const {
    children,
    ...PROPS
  } = props;

  useEffect(() => {
    console.log("***** 튜토리얼 페이지")
  }, [])
  
  return (
    <div className="layout-def layout-learning gm">
      <Header { ...PROPS } />
      <Body { ...PROPS } />

      {/* 연습장 Close BTN 추가 */}
      { TYPE.CHANNEL.GLOBAL01 === user.info.channelCode && answeringQuestions.isShowEntryClosePopup &&
        <Closer>
          <div className="lp-wrap opa_04">
              <div className="lp-btnBox">
                  <Button className="btn btn-wht_ble fade_in">Close</Button>
              </div>
          </div>
        </Closer>
      }
    </div>
  );

};

export default Tutorial;
